var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"clasa":"balance"}},[_c('v-icon',{staticClass:"stats-icon",attrs:{"color":"grey"}},[_vm._v("mdi-swap-vertical")]),_c('label',{staticClass:"stats-key"},[_vm._v("Balance ")]),_c('span',{class:{
            'red-color' : _vm.balance < 0,
            'green-color' : _vm.balance > 0,
            'yellow-color' : _vm.balance === 0
      }},[_vm._v(" "+_vm._s(_vm._f("round")(_vm.balance,0)))]),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }